exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sdr-chip--active{background:#ab3b7a}.sdr-chip--active .v-chip__content{color:#fff}", ""]);

// exports
